export default "__VITE_ASSET__BzOMd7rc__"